import * as routerNames from '@/services/router/router.names'

import WorkflowHome from '@/screens/workflows/workflow-home.vue'
import WorkflowDetail from '@/screens/workflows/workflow-detail.vue'

export default [
  {
    path: '/:accountId/workflows',
    name: routerNames.WORKFLOW_HOME,
    component: WorkflowHome,
  },
  {
    path: '/:accountId/workflows/:id',
    name: routerNames.WORKFLOW_DETAIL,
    component: WorkflowDetail,
  },
]
